import { createContext } from "react";

export const SimilarContext = createContext({
  similarDocuments: [],
  addSimilarDocument: () => {},
  removeSimilarDocument: () => {},
  resetSimilarDocuments: () => {},
  setSimilarDocuments: () => {}
});
